import camelize from 'camelcase-keys-deep';

export default class AttachmentPart {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  attachments() {
    return this.env().Attachment.findAllBy('attachmentPartId', this.id);
  }
}
